<template>
  <div id="memberships">
    <v-container class="-border">
      <v-layout wrap>
        <v-flex xs12 class="button-container pr-3 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons()">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout class="mb-5 mt-2 ml-4 flex-column" v-if="session.role() === 'agency'">
          <h4 class="mb-1">Signup Link</h4>
          <v-flex class="xs12 flex-row">
            <a :href="`${ config.newClient }/signup/?agencyId=${ Agency.id }`" target="_blank">{{ config.newClient }}/signup/?agencyId={{ Agency.id }}</a>
            <v-btn icon fab class="pf-bg-teal pf-text-white ma-0 ml-1" v-clipboard:copy="`${ config.newClient }/signup/?agencyId=${ Agency.id }`" v-clipboard:success="onCopyLink">
              <v-icon size="16">content_copy</v-icon>
            </v-btn>
          </v-flex>
      </v-layout>
      <v-form ref="membershipsForm">
        <h4 class="ml-4 mb-1">Memberships</h4>
        <v-layout wrap class="my-3">
          <v-flex sm6>
            <v-text-field label="Title" class="px-5 pf-font-18 font-weight-bold required" v-model="Agency.membership_name" :rules="[v => !!v || 'Please enter the membership title']" @input="changedData" :disabled="['agency', 'caseworker'].indexOf(session.role()) > -1 && !session.getSession().adminUser"></v-text-field>
          </v-flex>
        </v-layout>
        <h5 class="px-5 mb-3">Membership Types</h5>
        <v-layout wrap class="px-5 flex-column mb-4 membership-card" v-for="(membership, i) in memberships" :key="i">
          <v-layout class="xs12 sm6 mb-2">
            <!-- Delete button at top right corner -->
            <v-btn icon fab title="Remove" class="pf-bg-pink pf-text-white ma-0 right-15 pf-pos-absolute" v-if="memberships.length > 1 && session.getSession().adminUser || Agency.is_super_admin" @click="removeMembership(i)">
              <v-icon size="16">delete</v-icon>
            </v-btn>
            <v-text-field label="Name" class="required font-weight-bold" v-model="membership.name" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" :rules="[v => !!v || 'Name is required']" @input="changedData" :disabled="['agency', 'caseworker'].indexOf(session.role()) > -1 && !session.getSession().adminUser"></v-text-field>
          </v-layout>
          <v-layout wrap class="mb-4">
            <v-flex sm6 class="px-3">
              <label>Initial Amount:</label>
              <v-text-field class="required" v-model="membership.amount" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" :rules="[v => (!!v && !isNaN(v)) || 'Amount should be a valid integer']" @input="changedData" prepend-inner-icon="attach_money" :disabled="['agency', 'caseworker'].indexOf(session.role()) > -1 && !session.getSession().adminUser"></v-text-field>
            </v-flex>
            <v-flex sm6 class="px-3">
              <label>Recurring Amount:</label>
              <v-text-field class="required" v-model="membership.recurring_amount" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" :rules="[v => (!!v && !isNaN(v)) || 'Amount should be a valid integer']" @input="changedData" prepend-inner-icon="attach_money" :disabled="['agency', 'caseworker'].indexOf(session.role()) > -1 && !session.getSession().adminUser"></v-text-field>
            </v-flex>
            <v-layout v-if="membership && membership.name && session.role() === 'agency'" class="flex-row flex-top mt-3 px-3">
              <span class="pf-font-13">Signup Link:</span>
              <v-flex class="xs12 flex-row">
                <a :href="`${ config.newClient }/signup/?agencyId=${ Agency.id }&membership=${membership.name}`" target="_blank">{{ config.newClient }}/signup/?agencyId={{ Agency.id }}&membership={{ membership.name }}</a>
                <v-btn icon fab title="Click to copy" class="pf-bg-teal pf-text-white ma-0 ml-1" v-clipboard:copy="`${ config.newClient }/signup/?agencyId=${ Agency.id }&membership=${membership.name}`" v-clipboard:success="onCopyLink">
                  <v-icon size="16">content_copy</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout class="px-3">
              <v-switch
                  v-model="membership.enabled"
                  @change="changedData"
                  label="Active"
                  class="flex-end"
                  color="teal"
                >
              </v-switch>
            </v-layout>
            <!-- <v-flex sm3 class="px-3">
              <label>Recurring Billing Type:</label>
              <v-select class="required" v-model="membership.recurring_billing_type" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" @change="changedData" :items="['Day', 'Week', 'Month', 'Year']" :disabled="['agency', 'caseworker'].indexOf(session.role()) > -1 && !session.getSession().adminUser"></v-select>
            </v-flex> -->
            <!-- <v-flex sm3 class="px-3">
              <label>Recurring Billing Period <span v-if="membership.recurring_billing_type">({{ membership.recurring_billing_type.toLowerCase() + 's' }})</span>:</label>
              <v-text-field class="required" v-model="membership.recurring_billing_period" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" :rules="[v => (!!v && !isNaN(v)) || 'Value should be a valid integer']" @input="changedData" :disabled="['agency', 'caseworker'].indexOf(session.role()) > -1 && !session.getSession().adminUser"></v-text-field>
            </v-flex> -->
            <!-- <v-flex sm3 class="px-3">
              <label>First Bill After <span v-if="membership.recurring_billing_type">({{ membership.recurring_billing_type.toLowerCase() + 's' }})</span>:</label>
              <v-text-field class="required" v-model="membership.first_bill_after" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" :rules="[v => (!!v && !isNaN(v)) || 'Value should be a valid integer']" @input="changedData" :disabled="['agency', 'caseworker'].indexOf(session.role()) > -1 && !session.getSession().adminUser"></v-text-field>
            </v-flex> -->
            <!-- <v-flex sm3 class="px-3">
              <label>Membership Duration Type:</label>
              <v-select class="required" v-model="membership.duration_type" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" @change="changedData" :items="['Day', 'Week', 'Month', 'Year']" :disabled="['agency', 'caseworker'].indexOf(session.role()) > -1 && !session.getSession().adminUser"></v-select>
            </v-flex> -->
            <!-- <v-flex sm3 class="px-3">
              <label>Membership Duration <span v-if="membership.duration_type">({{ membership.duration_type.toLowerCase() + 's' }})</span>:</label>
              <v-text-field class="required" v-model="membership.duration_count" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" :rules="[v => (!!v && !isNaN(v)) || 'Value should be a valid integer']" @input="changedData" :disabled="['agency', 'caseworker'].indexOf(session.role()) > -1 && !session.getSession().adminUser"></v-text-field>
            </v-flex> -->
            <!-- <template v-if="session.role() === 'agency'">
              <v-flex class="xs12 sm3">
                <v-checkbox
                  v-model="membership.enabled"
                  color="teal"
                  @change="changedData"
                  :selected="typeof membership.enabled !== 'undefined' ? membership.enabled : true"
                  :value="typeof membership.enabled !== 'undefined' ? membership.enabled : true"
                  :label="'Active'"
                  class="px-3 pt-4">
                </v-checkbox>
              </v-flex>
            </template> -->
          </v-layout>

          <!-- <template v-if="session.role() === 'agency'">
            <v-flex class="xs12 sm3">
              <v-text-field label="Coupon code (optional)" v-model="membership.code" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" @input="changedData"></v-text-field>
            </v-flex>
            <v-flex class="xs12 sm5 flex-column" v-if="membership.code && membership.active">
              <a :href="`${ config.WPParams.host }/membership-checkout?level=${ membershipWPIds[membership.name] }&discount_code=${ membership.code }&mapping_id=${ Agency.mapping_id }`" target="_blank">{{ config.WPParams.host }}/membership-checkout?level={{ membershipWPIds[membership.name] }}&discount_code={{membership.code}}&mapping_id={{ Agency.mapping_id }}</a>
              <v-btn icon fab class="pf-bg-green pf-text-white ma-0" v-clipboard:copy="`${ config.WPParams.host }/membership-checkout?level=${ membershipWPIds[membership.name] }&discount_code=${ membership.code }&mapping_id=${ Agency.mapping_id }`" v-clipboard:success="onCopyLink">
                <v-icon size="16">content_copy</v-icon>
              </v-btn>
            </v-flex>
          </template> -->
        </v-layout>
        <v-layout class="mx-5" v-if="Agency.is_super_admin || session.getSession().adminUser">
          <v-btn class="pf-btn pf-btn-save pf-bg-teal" @click="addNewMembership">
            <div>Add Membership</div>
          </v-btn>
        </v-layout>
        <v-layout wrap class="pr-4 pl-4 flex-column my-4" v-if="session.role() === 'agency'">
          <h4>Membership Payment</h4>
          <v-radio-group label="How will the payment be done for the families?" v-model="account_settings.paymentDoneBy" class="px-4" @change="changedData">
            <v-radio label="Family pay" value="family" color="teal" :selected="account_settings.paymentDoneBy"></v-radio>
            <v-radio label="Organization pay" value="agency" color="teal" :selected="account_settings.paymentDoneBy"></v-radio>
          </v-radio-group>
        </v-layout>

        <!-- Additional agency fee -->
        <v-layout class="pr-4 pl-4 flex-column my-4">
          <h4>Display Fee</h4>
          <!-- A radio input to check if there is a fee -->
          <v-radio-group label="Is there a fee when a family from another organization requests to join yours?" v-model="Agency.is_additional_display_fee" class="px-4" @change="changedData">
            <v-radio label="Yes" :value="true" color="teal" :selected="Agency.is_additional_display_fee"></v-radio>
            <v-radio label="No" :value="false" color="teal" :selected="Agency.is_additional_display_fee"></v-radio>
          </v-radio-group>
          <!-- If there is a fee, get the fee -->
          <v-layout wrap class="px-2 mt-2 flex-column mb-2" v-if="Boolean(Agency.is_additional_display_fee)">
            <v-layout wrap class="mb-4">
              <v-flex sm3 class="px-3">
                <label>Initial Amount:</label>
                <v-text-field class="required" v-model="Agency.additional_display_fee.amount" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" :rules="[v => (!!v && !isNaN(v)) || 'Amount should be a valid integer']" @input="changedData" prepend-inner-icon="attach_money" :disabled="['agency', 'caseworker'].indexOf(session.role()) > -1 && !session.getSession().adminUser"></v-text-field>
              </v-flex>
              <v-flex sm3 class="px-3">
                <label>Recurring Amount:</label>
                <v-text-field class="required" v-model="Agency.additional_display_fee.recurring_amount" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" :rules="[v => (!!v && !isNaN(v)) || 'Amount should be a valid integer']" @input="changedData" prepend-inner-icon="attach_money" :disabled="['agency', 'caseworker'].indexOf(session.role()) > -1 && !session.getSession().adminUser"></v-text-field>
              </v-flex>
              <!-- <v-flex sm3 class="px-3">
                <label>Recurring Billing Type:</label>
                <v-select class="required" v-model="Agency.additional_display_fee.recurring_billing_type" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" @change="changedData" :items="['Days', 'Months']" :disabled="['agency', 'caseworker'].indexOf(session.role()) > -1 && !session.getSession().adminUser"></v-select>
              </v-flex>
              <v-flex sm3 class="px-3">
                <label>Recurring Billing Period <span v-if="Agency.additional_display_fee.recurring_billing_type">({{ Agency.additional_display_fee.recurring_billing_type.toLowerCase() }})</span>:</label>
                <v-text-field class="required" v-model="Agency.additional_display_fee.recurring_billing_period" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" :rules="[v => (!!v && !isNaN(v)) || 'Value should be a valid integer']" @input="changedData" :disabled="['agency', 'caseworker'].indexOf(session.role()) > -1 && !session.getSession().adminUser"></v-text-field>
              </v-flex>
              <v-flex sm3 class="px-3">
                <label>First Bill After <span v-if="Agency.additional_display_fee.recurring_billing_type">({{ Agency.additional_display_fee.recurring_billing_type.toLowerCase() }})</span>:</label>
                <v-text-field class="required" v-model="Agency.additional_display_fee.first_bill_after" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" :rules="[v => (!!v && !isNaN(v)) || 'Value should be a valid integer']" @input="changedData" :disabled="['agency', 'caseworker'].indexOf(session.role()) > -1 && !session.getSession().adminUser"></v-text-field>
              </v-flex> -->
            </v-layout>
          </v-layout>
        </v-layout>
      </v-form>
    </v-container>

    <v-container class="-border">
      <v-layout class="pr-4 pl-4 flex-column mb-2">
        <h4>Membership Names</h4>
        <p class="mt-3 pf-text-default">Add the membership names that will be used in the system</p>
      </v-layout>
      <v-layout wrap class="mb-2" v-for="(name, i) in membershipNames" :key="i">
        <v-flex sm6>
          <v-text-field :value="name" :label="`Membership name ${i + 1}`" @input="(e) => { changeMembershipName(e, i) }" class="pr-4 pl-4"></v-text-field>
        </v-flex>
        <v-flex sm6>
          <v-btn
            v-if="i !== 0"
            class="pf-btn-text-white pf-bg-pink"
            @click="removeMembershipName(i)"
          >
            Remove
          </v-btn>
          <v-btn
            v-if="i === membershipNames.length - 1"
            class="pf-btn-text-white pf-bg-green"
            @click="addNewMembershipName"
          >
            Add More
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container class="-border">
      <v-layout wrap class="pr-4 pl-4 mt-4" v-if="selectedData">
        <v-flex xs12 class="button-container pr-0 text-xs-right">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons()">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container class="-border" v-if="session.role() === 'admin'">
      <v-layout wrap class="pr-4 pl-4 pf-d-flex-align-center mb-2">
        <h4>Membership Subscription Import</h4>
        <p class="mt-3 pf-text-default">Upload the CSV file to import family memberships subscription data, please make sure the file has PPN and Authorize.net payment subscription ID (headers - ppn and subscription_id)</p>
        <upload-btn class="pl-0" @file-update="fileSelected($event)" title="Upload CSV" noTitleUpdate ref="subscriptionsDoc">
          <template slot="icon-left">
            <v-icon size="16" class="pr-1">upload</v-icon>
          </template>
        </upload-btn>
      </v-layout>
    </v-container>

    <v-form ref="membershipSettingsForm" v-if="session.role() === 'admin'">
      <v-container class="-border">
        <v-layout wrap class="pr-4 pl-4 mt-4" v-if="changedSettings">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="hideSettingsButtons()">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="saveSettings">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pr-4 pl-4 flex-column mb-2">
          <h4>Upcoming Membership Payments</h4>
          <p class="mt-3 pf-text-default">Number of days to notify families prior to their upcoming membership payment</p>
          <v-flex xs6>
            <v-text-field label="Please enter the no. of days" v-model.trim="family_notification_settings.subscription_expiry_days" class="required" :rules="formRules.integer" @input="settingsChanged"></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout wrap class="pr-4 pl-4 flex-column mb-2">
          <h4>Membership Retaining Days</h4>
          <p class="mt-3 pf-text-default">Number of days to keep the account active after cancelling/expiring the membership subscription</p>
          <v-flex xs6>
            <v-text-field label="Please enter the no. of days" v-model.trim="account_settings.subscription_retain_days" class="required" :rules="formRules.integer" @input="settingsChanged"></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout wrap class="pr-4 pl-4 mt-4" v-if="changedSettings">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="hideSettingsButtons()">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="saveSettings">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>      
    </v-form>
  </div>
</template>

<script>
/* global session store config  */
import Vue from 'vue';
import swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import { update, uploadFile } from '../helpers/helpers';
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
import UploadButton from 'vuetify-upload-button';

export default {
  name: 'memberships',
  components: {
    'upload-btn': UploadButton,
  },
  data: () => ({
    entity: 'Agency',
    config: config,
    selectedData: false,
    changedSettings: false,
    formRules: {
      agencyType: [v => !!v || 'Agency Type is required'],
      positive_number: [v => !!v || 'Please enter valid number', v => /^\d+$/.test(v) || 'Please enter valid number'],
      integer: [
        v => !!v || 'Type is required',
        // eslint-disable-next-line
        v => (!isNaN(v) && v != 0) || 'Please enter a valid number',
      ]
    },
    membershipsBackup: [],
    memberships: [
      {
        name: 'Network',
        amount: 300,
        recurring_amount: 300,
        code: '',
        active: false
      },
      {
        name: 'Featured',
        amount: 750,
        recurring_amount: 750,
        code: '',
        active: false
      },
      {
        name: 'Preferred',
        amount: 2000,
        recurring_amount: 2000,
        code: '',
        active: false
      }
    ],
    membershipNames: [''],
    family_notification_settings: {
      subscription_expiry_days: 5
    },
    family_notification_settings_backup: {},
    account_settings: {
      subscription_retain_days: 5,
      paymentDoneBy: 'family'
    },
    account_settings_backup: {},
    membershipWPIds: {
      'Network': 1,
      'Featured': 2,
      'Preferred': 3
    }
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    }
  },
  watch: {
    membershipNames: {
      handler (val) {
        this.Agency.membership_names = val;
        this.changedData();
      },
      deep: true
    }
  },
  async created () {
    await this.initialize();
    this.membershipsBackup = JSON.parse(JSON.stringify(this.memberships));
    this.Agency.membership_name = this.Agency.membership_name || '';
    this.family_notification_settings_backup = JSON.parse(JSON.stringify(this.family_notification_settings));
    this.account_settings_backup = JSON.parse(JSON.stringify(this.account_settings));

    // Set the agency additional display fee
    if (typeof this.Agency.is_additional_display_fee === 'undefined') {
      this.Agency.is_additional_display_fee = false;
    }
    if (!this.Agency.additional_display_fee) {
      this.Agency.additional_display_fee = {
        amount: '',
        recurring_amount: '',
        // recurring_billing_type: 'Months',
        // recurring_billing_period: 1,
        // first_bill_after: 1
      };
    }
    if (this.Agency.membership_names && this.Agency.membership_names.length) {
      this.membershipNames = JSON.parse(JSON.stringify(this.Agency.membership_names));
    }
  },
  methods: {
    async initialize () {
      /* Set the memberships from agency */
      if (this.Agency && this.Agency.memberships && this.Agency.memberships.length) {
        this.memberships = JSON.parse(JSON.stringify(this.Agency.memberships));
        /* Set the recurring_amount - added later */
        this.memberships = this.memberships.map(x => {
          if (typeof x.recurring_amount === 'undefined') {
            x.recurring_amount = x.amount;
          }
          if (typeof x.enabled === 'undefined') {
            x.enabled = true;
          }
          // if (typeof x.recurring_billing_period === 'undefined') {
          //   x.recurring_billing_period = 1;
          // }
          // if (typeof x.recurring_billing_type === 'undefined') {
          //   x.recurring_billing_type = 'Month';
          // }
          // if (typeof x.first_bill_after === 'undefined') {
          //   x.first_bill_after = 1;
          // }
          // if (typeof x.duration_type === 'undefined') {
          //   x.duration_type = 'Year';
          // }
          // if (typeof x.duration_count === 'undefined') {
          //   x.duration_count = 1;
          // }
          return x;
        });
      }
      /* Set the code - added later */
      this.setMembershipCodes(this.Agency.memberships && this.Agency.memberships.length);

      /* Set the settings */
      if (this.Agency && this.Agency.family_notification_settings && Object.keys(this.Agency.family_notification_settings).length) {
        this.family_notification_settings = JSON.parse(JSON.stringify(this.Agency.family_notification_settings));
      }
      if (this.Agency && this.Agency.account_settings && Object.keys(this.Agency.account_settings).length) {
        this.account_settings = JSON.parse(JSON.stringify(this.Agency.account_settings));
      }
      if (!this.account_settings.paymentDoneBy) {
        this.account_settings.paymentDoneBy = 'family';
      }

      if (!this.family_notification_settings.subscription_expiry_days) {
        this.family_notification_settings.subscription_expiry_days = 5;
      }
      if (!this.account_settings.subscription_retain_days) {
        this.account_settings.subscription_retain_days = 5;
      }
    },
    removeMembership (index) {
      const self = this;
      // Confirmation dialog
      swal.fire({
        title: 'Are you sure?',
        text: 'You want to remove this membership?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        confirmButtonColor: '#f00',
        cancelButtonColor: '#3085d6',
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          self.memberships.splice(index, 1);
          self.changedData();
        }
      });
    },
    addNewMembership () {
      this.memberships.push({
        name: '',
        amount: '',
        recurring_amount: '',
        enabled: true
      });
    },
    addNewMembershipName () {
      this.membershipNames = [...this.membershipNames, ''];
    },
    removeMembershipName (index) {
      this.membershipNames.splice(index, 1);
      this.membershipNames = this.membershipNames;
      this.changedData();
    },
    changeMembershipName (e, index) {
      this.membershipNames[index] = e;
      this.membershipNames = this.membershipNames;
      this.changedData();
    },
    async fileSelected (file) {
      if (['text/csv', 'application/vnd.ms-excel'].indexOf(file.type) === -1) {
        swal.fire({
          type: 'warning',
          title: 'Incorrect File Format',
          text: `Please choose a CSV file`,
          showConfirmButton: true,
          onClose: () => {}
        });
        return;
      }
      if (file !== 'undefined') {
        this.fileName = file.name;
        if (this.fileName.lastIndexOf('.') <= 0) {
          this.selectedData = true;
          return;
        }
        if (file.size > this.config.uploadFileSize) {
          swal.fire({
            title: `<strong>Upload error</strong>`,
            type: 'error',
            html: 'Maximum file upload size is ' + (this.config.uploadFileSize / 1024 / 1024) + ' MB',
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: 'Close',
          });
          this.selectedData = true;
          this.$refs.subscriptionsDoc.clear();
          return;
        }
        window.getApp.$emit('AppProgress', true);
        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener('load', async () => {
          let postUrl = 'PaymentSubscription/UploadSubscriptions';
          let response = await uploadFile(postUrl, file, 'POST', {});
          if (response.$error) {
            window.getApp.$emit('AppProgress', false);
            console.log('error', response.$error);
            this.snackbar = {
              show: true,
              color: 'red',
              text: response.$error
            };
            this.$refs.subscriptionsDoc.clear();
          } else {
            this.$refs.subscriptionsDoc.clear();
            swal.fire({
              type: 'success',
              title: 'Membership subscriptions uploaded successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                window.getApp.$emit('AppProgress', false);
              }
            });
          }
        });
      }
    },
    onCopyLink () {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'The link copied to clipboard'
      };
    },
    setMembershipCodes (hasAgencyMemberships) {
      this.memberships = this.memberships.map(x => {
        if (typeof x.code === 'undefined') {
          x.code = '';
          x.active = false;
        } else if (x.code && x.code !== '' && hasAgencyMemberships) {
          /* Set the active */
          x.active = true;
        } else if (!x.code || x.code === '') {
          /* Set the active */
          x.active = false;
        }
        return x;
      });
    },
    
    changedData () {
      this.selectedData = true;
    },
    settingsChanged () {
      this.changedSettings = true;
    },
    hideButtons () {
      this.selectedData = false;
      this.memberships = this.Agency.memberships && this.Agency.memberships.length ? JSON.parse(JSON.stringify(this.Agency.memberships)) : this.membershipsBackup;
    },
    hideSettingsButtons () {
      this.changedSettings = false;
      this.family_notification_settings = this.Agency.family_notification_settings && this.Agency.family_notification_settings.length ? JSON.parse(JSON.stringify(this.Agency.family_notification_settings)) : this.family_notification_settings_backup;
      this.account_settings = this.Agency.account_settings && this.Agency.account_settings.length ? JSON.parse(JSON.stringify(this.Agency.account_settings)) : this.account_settings_backup;
    },
    async save () {
      if (this.$refs.membershipsForm.validate()) {
        this.Agency.updated_from = 'memberships';
        this.Agency.account_settings = this.account_settings;
        this.Agency.memberships = this.memberships.filter(x => {
          return x.name && typeof x.amount !== 'undefined' && typeof x.recurring_amount !== 'undefined';
        }).map(x => {
          x.amount = Number(x.amount);
          return x;
        });
        this.Agency.membership_names = this.membershipNames.filter(x => {
          return x && x.trim() !== '';
        });

        let { error, data, status } = await update(this.entity, this.Agency, session.getSession().adminUser ? session.getSession().user.human.agency : 'Me');
        if (error) {
          console.log('error', error);
        } else {
          this.Agency = Object.assign({}, data);
          await this.initialize();
          swal.fire({
            type: 'success',
            title: 'Memberships saved successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.selectedData = false;
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    },
    async saveSettings () {
      if (this.$refs.membershipSettingsForm.validate()) {
        this.Agency.updated_from = 'basic';
        this.Agency.family_notification_settings = this.family_notification_settings;
        this.Agency.account_settings = this.account_settings;
        let { error, data, status } = await update(this.entity, this.Agency, session.getSession().adminUser ? session.getSession().user.human.agency : 'Me');
        if (error) {
          console.log('error', error);
        } else {
          this.Agency = Object.assign({}, data);
          await this.initialize();
          swal.fire({
            type: 'success',
            title: 'Membership settings saved successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.selectedData = false;
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    }
  }
};
</script>

<style lang="css" scoped>

.membership-card {
  border: 1px solid #ccc;
  border-radius: 15px;
  padding: 15px;
  margin: 0 45px;
  width: 70%;
  box-shadow: 2px 0px 10px #ccc;
  position: relative;
}

</style>



// WEBPACK FOOTER //
// src/pages/Memberships.vue